<template>
  <div class="orderListStyle">
    <top-component></top-component>
    <div class="orderContent">
      <el-table :data="tableData" style="width: 100%;margin-top: 30px;" @row-click="rowClick">
        <el-table-column prop="createTime" label="日期">
        </el-table-column>
        <el-table-column prop="remark" label="订单">
        </el-table-column>
        <el-table-column prop="totalPrice" label="总价">
        </el-table-column>
      </el-table>
    </div>
    <bottom-component></bottom-component>
  </div>
</template>

<script>
  import TopComponent from '../Components/TopComponent.vue'
  import BottomComponent from '../Components/BottomComponent.vue'
  export default {
    name: 'HelloWorld',
    data() {
      return {
        tableData: []
      }
    },
    mounted() {
      this.tableData = JSON.parse(this.$route.query.item)
    },
    methods: {
      rowClick(row, column, event) {
        this.$router.push({ name: 'OrderDetail', query: { orderId: row.orderId } })
      }
    },
    components: { TopComponent, BottomComponent }
  }
</script>

<style scoped lang="scss">
  .orderListStyle {
    width: 100%;
    background-color: #f9f9f9;
    overflow-x: hidden;
  }

  .orderContent {
    width: 1200px;
    margin-left: calc(50% - 600px);
  }
</style>



// WEBPACK FOOTER //
// src/views/ChildPages/Order-List.vue